import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from 'axios';
import axios from 'axios';

/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * SsoProvider
 * An enumeration.
 */
export enum SsoProvider {
  Google = 'google',
  Microsoft = 'microsoft',
}

/**
 * SelectedApp
 * An enumeration.
 */
export enum SelectedApp {
  Sr = 'sr',
  Compliance = 'compliance',
  Loans = 'loans',
  Academy = 'academy',
}

/**
 * KeycloakRole
 * An enumeration.
 */
export enum KeycloakRole {
  SrAdmin = 'sr_admin',
  SrInvestor = 'sr_investor',
  SrIssuer = 'sr_issuer',
  SrIssuerAdmin = 'sr_issuer_admin',
  ComplianceAdmin = 'compliance_admin',
  ComplianceUser = 'compliance_user',
  LoansAdmin = 'loans_admin',
  LoansUser = 'loans_user',
  AcademyUser = 'academy_user',
  AcademyOrganisationAdmin = 'academy_organisation_admin',
}

/**
 * KeycloakCredentialType
 * An enumeration.
 */
export enum KeycloakCredentialType {
  Password = 'password',
}

/** AddOrganizationMemberResponse */
export interface AddOrganizationMemberResponse {
  /** Success */
  success: boolean;
}

/** AddOrganizationRoleRequest */
export interface AddOrganizationRoleRequest {
  /** Organization Id */
  organization_id: string;
  /** User Id */
  user_id: string;
  /** An enumeration. */
  role: KeycloakRole;
}

/** AddOrganizationRoleResponse */
export interface AddOrganizationRoleResponse {
  /** Success */
  success: boolean;
}

/** CreateBillingPortalSessionBody */
export interface CreateBillingPortalSessionBody {
  /** Organization Id */
  organization_id: string;
  /** Return Url */
  return_url?: string;
}

/** CreateBillingPortalSessionResponse */
export interface CreateBillingPortalSessionResponse {
  /** Portal Url */
  portal_url: string;
}

/** CreateCheckoutSessionBody */
export interface CreateCheckoutSessionBody {
  /** Product */
  product: string;
  /** Billing Cycle */
  billing_cycle?: 'monthly' | 'annual';
  /** Selected Apps */
  selected_apps?: SelectedApp[] | null;
}

/** CreateCheckoutSessionResponse */
export interface CreateCheckoutSessionResponse {
  /** Checkout Url */
  checkout_url: string;
}

/** CreateMagicLinkRequest */
export interface CreateMagicLinkRequest {
  /** Email */
  email: string;
  /** Expiration Seconds */
  expiration_seconds: number;
  /** Redirect Uri */
  redirect_uri?: string;
  /** User Id */
  user_id: string;
}

/** CreateMagicLinkResponse */
export interface CreateMagicLinkResponse {
  /** Data */
  data: object;
}

/** CreateOrganizationRequest */
export interface CreateOrganizationRequest {
  /** Id */
  id: string;
  /** Name */
  name: string;
  /** Displayname */
  displayName: string;
  /** Url */
  url: string;
  /** Domains */
  domains: string[];
  /** Attributes */
  attributes: object;
}

/** CreateOrganizationResponse */
export interface CreateOrganizationResponse {
  /** Data */
  data: string;
}

/** CreateUserRequest */
export interface CreateUserRequest {
  /**
   * Username
   * @minLength 3
   * @maxLength 255
   */
  username: string;
  /** Emailverified */
  emailVerified: boolean;
  /**
   * Email
   * @minLength 3
   * @maxLength 255
   */
  email: string;
  /**
   * Firstname
   * @minLength 3
   * @maxLength 255
   */
  firstName: string;
  /**
   * Lastname
   * @minLength 3
   * @maxLength 255
   */
  lastName: string;
  /** Enabled */
  enabled: boolean;
  /** Credentials */
  credentials: KeycloakCredentials[];
  roles: KeycloakRole[];
  /**
   * Force Create
   * @default false
   */
  force_create?: boolean;
  /**
   * Send Email
   * @default false
   */
  send_email?: boolean;
  /** Redirect Url */
  redirect_url?: string;
  /**
   * Required Update Password
   * @default false
   */
  required_update_password?: boolean;
  /**
   * Required Configure Otp
   * @default false
   */
  required_configure_otp?: boolean;
  /** Magic Link Expiration Time */
  magic_link_expiration_time?: number;
  /** Organization Ids */
  organization_ids?: string[];
}

/** CreateUserResponse */
export interface CreateUserResponse {
  /** Data */
  data: object;
}

/** DeleteOrganizationMemberResponse */
export interface DeleteOrganizationMemberResponse {
  /** Success */
  success: boolean;
}

/** DeleteOrganizationResponse */
export interface DeleteOrganizationResponse {
  /** Success */
  success: boolean;
}

/** DeleteOrganizationRoleRequest */
export interface DeleteOrganizationRoleRequest {
  /** Organization Id */
  organization_id: string;
  /** User Id */
  user_id: string;
  /** An enumeration. */
  role: KeycloakRole;
}

/** DeleteOrganizationRoleResponse */
export interface DeleteOrganizationRoleResponse {
  /** Success */
  success: boolean;
}

/** DeleteUserComplianceRoleRequest */
export interface DeleteUserComplianceRoleRequest {
  /** User Id */
  user_id: string;
  /** Organization Id */
  organization_id: string;
  /** An enumeration. */
  role: KeycloakRole;
}

/** DeleteUserComplianceRoleResponse */
export interface DeleteUserComplianceRoleResponse {
  /** Success */
  success: boolean;
}

/** GetBillingOverviewResponse */
export interface GetBillingOverviewResponse {
  /** Status */
  status: string;
  /**
   * Current Billing Period Start
   * @format date-time
   */
  current_billing_period_start?: string;
  /**
   * Next Invoice Date
   * @format date-time
   */
  next_invoice_date?: string;
  /** Has Portal Access */
  has_portal_access: boolean;
}

/** GetOrganizationByIdResponse */
export interface GetOrganizationByIdResponse {
  data: Organization;
}

/** GetOrganizationMemberResponse */
export interface GetOrganizationMemberResponse {
  /** Data */
  data: string[];
}

/**
 * GetOrganizationsForUsersResponse
 * The response contains a dictionary where each user ID maps to a list of organization IDs.
 *
 * Example response:
 * {
 *     "data": {
 *         "user_1_id": ["org_1_id", "org_2_id"],
 *         "user_2_id": ["org_2_id"]
 *     }
 * }
 */
export interface GetOrganizationsForUsersResponse {
  /** Data */
  data: Record<string, string[]>;
}

/** GetSubscriptionStatusResponse */
export interface GetSubscriptionStatusResponse {
  /** Status */
  status: string;
  /** Magic Link */
  magic_link?: string;
  /** Next Step */
  next_step?: string;
}

/** GetUserDetailByUserIdResponse */
export interface GetUserDetailByUserIdResponse {
  data: KeycloakUserDetail;
}

/** GetUsersByOrganizationRoleResponse */
export interface GetUsersByOrganizationRoleResponse {
  /** Data */
  data: object;
}

/** GetUsersByRoleResponse */
export interface GetUsersByRoleResponse {
  /** Data */
  data: string[];
}

/** GetUsersOrganizationListResponse */
export interface GetUsersOrganizationListResponse {
  /** Data */
  data: string[];
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/** KeycloakCredentials */
export interface KeycloakCredentials {
  /** An enumeration. */
  type: KeycloakCredentialType;
  /** Value */
  value: string;
}

/** KeycloakUserDetail */
export interface KeycloakUserDetail {
  /** Id */
  id: string;
  /** Username */
  username: string;
  /** Email */
  email: string;
  /** First Name */
  first_name?: string;
  /** Last Name */
  last_name?: string;
  /** Attributes */
  attributes?: Record<string, string[]>;
}

/** Organization */
export interface Organization {
  /** Id */
  id?: string;
  /** Name */
  name?: string;
  /** Displayname */
  displayName?: string;
  /** Url */
  url?: string;
  /** Realm */
  realm?: string;
  /** Domains */
  domains?: string[];
  /** Attributes */
  attributes?: Record<string, string[]>;
  /**
   * Is Need Create Base Roles
   * @default false
   */
  is_need_create_base_roles?: boolean;
}

/** ResetUserTotpResponse */
export interface ResetUserTotpResponse {
  /** Success */
  success: boolean;
}

/**
 * SignupCompanyBody
 * Request body for the /company endpoint — public fields from the client.
 */
export interface SignupCompanyBody {
  /** @minItems 1 */
  selected_apps: SelectedApp[];
  /**
   * Company Name
   * @minLength 1
   * @maxLength 255
   */
  company_name: string;
}

/** SignupCompanyResponse */
export interface SignupCompanyResponse {
  data: SignupCompanyResponseData;
  /** Magic Link */
  magic_link?: string;
}

/** SignupCompanyResponseData */
export interface SignupCompanyResponseData {
  /** Organization Id */
  organization_id: string;
}

/** SignupHandoffBody */
export interface SignupHandoffBody {
  /**
   * Access Token
   * @minLength 1
   */
  access_token: string;
}

/** SignupOnboardingStatusResponse */
export interface SignupOnboardingStatusResponse {
  selected_apps?: SelectedApp[];
  /**
   * Next Step
   * @default "app_selector"
   */
  next_step?: string;
  /** Subscription Status */
  subscription_status?: string;
  /**
   * Billing Action Required
   * @default false
   */
  billing_action_required?: boolean;
  /**
   * Has Billing Portal Access
   * @default false
   */
  has_billing_portal_access?: boolean;
  sr?: SignupProductReadiness;
  compliance?: SignupProductReadiness;
  loans?: SignupProductReadiness;
}

/** SignupBillingPortalSessionBody */
export interface SignupBillingPortalSessionBody {
  /** Return Url */
  return_url?: string;
}

/** SignupBillingPortalSessionResponse */
export interface SignupBillingPortalSessionResponse {
  /** Portal Url */
  portal_url: string;
}

/** SignupProductReadiness */
export interface SignupProductReadiness {
  /**
   * Ready
   * @default false
   */
  ready?: boolean;
}

/** SignupRequest */
export interface SignupRequest {
  /**
   * Email
   * @minLength 3
   * @maxLength 255
   */
  email: string;
  /**
   * Password
   * @minLength 8
   * @maxLength 255
   */
  password: string;
  /**
   * First Name
   * @minLength 1
   * @maxLength 255
   */
  first_name: string;
  /**
   * Last Name
   * @minLength 1
   * @maxLength 255
   */
  last_name: string;
  /** @minItems 1 */
  selected_apps: SelectedApp[];
}

/** SignupResponse */
export interface SignupResponse {
  data: SignupResponseData;
  /** Magic Link */
  magic_link?: string;
  /** Signup Session */
  signup_session?: string;
  /**
   * Already Exists
   * @default false
   */
  already_exists?: boolean;
}

/** SignupResponseData */
export interface SignupResponseData {
  /** User Id */
  user_id: string;
}

/** SignupSessionResponse */
export interface SignupSessionResponse {
  /** Signup Session */
  signup_session?: string;
  /** Email */
  email: string;
  selected_apps?: SelectedApp[];
  /**
   * Is Handoff
   * @default false
   */
  is_handoff?: boolean;
  /**
   * Next Step
   * @default "app_selector"
   */
  next_step?: string;
  /** Subscription Status */
  subscription_status?: string;
  /**
   * Billing Action Required
   * @default false
   */
  billing_action_required?: boolean;
  /**
   * Has Billing Portal Access
   * @default false
   */
  has_billing_portal_access?: boolean;
  /** Magic Link */
  magic_link?: string;
}

/** UpdateSignupSelectionBody */
export interface UpdateSignupSelectionBody {
  /** @minItems 1 */
  selected_apps: SelectedApp[];
}

/** SignupSsoBody */
export interface SignupSsoBody {
  /** @minItems 1 */
  selected_apps: SelectedApp[];
}

/** SignupSsoResponse */
export interface SignupSsoResponse {
  data: SignupSsoResponseData;
  /** Magic Link */
  magic_link?: string;
}

/** SignupSsoResponseData */
export interface SignupSsoResponseData {
  /** User Id */
  user_id: string;
}

/** SsoCallbackRequest */
export interface SsoCallbackRequest {
  /** An enumeration. */
  provider: SsoProvider;
  /**
   * Code
   * @minLength 1
   */
  code: string;
  /**
   * Redirect Uri
   * @minLength 1
   */
  redirect_uri: string;
  /**
   * Code Verifier
   * @minLength 1
   */
  code_verifier: string;
  /** @minItems 1 */
  selected_apps: SelectedApp[];
}

/** SsoCallbackResponse */
export interface SsoCallbackResponse {
  /**
   * Success
   * @default true
   */
  success?: boolean;
  /** Signup Session */
  signup_session?: string;
}

/** SsoLoginResponse */
export interface SsoLoginResponse {
  /** Magic Link */
  magic_link?: string;
  /** Email */
  email?: string;
}

/** UpdateOrganizationData */
export interface UpdateOrganizationData {
  /** Id */
  id?: string;
  /** Name */
  name?: string;
  /** Displayname */
  displayName?: string;
  /** Url */
  url?: string;
  /** Realm */
  realm?: string;
  /** Domains */
  domains?: string[];
  /** Attributes */
  attributes?: Record<string, string[]>;
  /**
   * Is Need Create Base Roles
   * @default false
   */
  is_need_create_base_roles?: boolean;
}

/** UpdateOrganizationRequest */
export interface UpdateOrganizationRequest {
  /** Organization Id */
  organization_id: string;
  data: UpdateOrganizationData;
}

/** UpdateOrganizationResponse */
export interface UpdateOrganizationResponse {
  /** Success */
  success: boolean;
}

/** UpdateSignupReadinessRequest */
export interface UpdateSignupReadinessRequest {
  /** User Id */
  user_id: string;
  /** Sr Signup Ready */
  sr_signup_ready?: boolean;
  /** Compliance Signup Ready */
  compliance_signup_ready?: boolean;
  /** Loans Signup Ready */
  loans_signup_ready?: boolean;
}

/** UpdateSignupReadinessResponse */
export interface UpdateSignupReadinessResponse {
  /** Success */
  success: boolean;
}

/** UpdateUserByComplianceAdminRequest */
export interface UpdateUserByComplianceAdminRequest {
  /** User Id */
  user_id?: string;
  /** Organization Id */
  organization_id: string;
  /**
   * Firstname
   * @minLength 3
   * @maxLength 255
   */
  firstName: string;
  /**
   * Lastname
   * @minLength 3
   * @maxLength 255
   */
  lastName: string;
}

/** UpdateUserByComplianceAdminResponse */
export interface UpdateUserByComplianceAdminResponse {
  /** Success */
  success: boolean;
}

/** UpdateUserComplianceRoleRequest */
export interface UpdateUserComplianceRoleRequest {
  /** User Id */
  user_id: string;
  /** Organization Id */
  organization_id: string;
  /** An enumeration. */
  role: KeycloakRole;
}

/** UpdateUserComplianceRoleResponse */
export interface UpdateUserComplianceRoleResponse {
  /** Success */
  success: boolean;
}

/** UpdateUserIssuerRoleRequest */
export interface UpdateUserIssuerRoleRequest {
  /** User Id */
  user_id: string;
  /** Organization Id */
  organization_id: string;
  /** An enumeration. */
  role: KeycloakRole;
}

/** UpdateUserIssuerRoleResponse */
export interface UpdateUserIssuerRoleResponse {
  /** Success */
  success: boolean;
}

/** UpdateUserRequest */
export interface UpdateUserRequest {
  /**
   * Firstname
   * @minLength 3
   * @maxLength 255
   */
  firstName?: string;
  /**
   * Lastname
   * @minLength 3
   * @maxLength 255
   */
  lastName?: string;
  /** Avatar */
  avatar?: string | null;
  /** Has Seen Welcome Sr */
  has_seen_welcome_sr?: boolean;
  /** Has Seen Welcome Compliance */
  has_seen_welcome_compliance?: boolean;
}

/** UpdateUserResponse */
export interface UpdateUserResponse {
  /** Data */
  data: object;
}

/** UpdateUserTotpStatusPayload */
export interface UpdateUserTotpStatusPayload {
  /** Enabled */
  enabled: boolean;
}

/** UpdateUserTotpStatusResponse */
export interface UpdateUserTotpStatusResponse {
  /** Success */
  success: boolean;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
}

/** VerifyCheckoutSessionBody */
export interface VerifyCheckoutSessionBody {
  /** Session Id */
  session_id: string;
}

/** VerifyCheckoutSessionResponse */
export interface VerifyCheckoutSessionResponse {
  /** Verified */
  verified: boolean;
  /** Magic Link */
  magic_link?: string;
  /** Next Step */
  next_step?: string;
}

export interface GetUserOrganizationListV1UsersUserIdOrganizationsGetParams {
  /** User Id */
  userId: string;
}

export interface GetUsersByRoleV1UsersByRoleGetParams {
  /** An enumeration. */
  role: KeycloakRole;
}

export interface GetUserDetailsByUserIdV1UsersDetailsUserIdGetParams {
  /** User Id */
  userId: string;
}

export interface UpdateUserProfileByComplianceAdminV1UsersUserIdProfilePutParams {
  /** User Id */
  userId: string;
}

export interface UpdateUserTotpStatusV1UsersUserIdOtpPostParams {
  /** User Id */
  userId: string;
}

export interface ResetUserTotpV1UsersUserIdReset2FaPostParams {
  /** User Id */
  userId: string;
}

export interface DeleteOrganizationV1OrganizationsOrganizationOrganizationIdDeleteParams {
  /** Organization Id */
  organizationId: string;
}

export interface AddOrganizationMemberV1OrganizationsOrganizationMemberOrganizationIdMemberUserIdRoleRolePutParams {
  /** Organization Id */
  organizationId: string;
  /** User Id */
  userId: string;
  /** An enumeration. */
  role: KeycloakRole;
}

export interface GetOrganizationMemberV1OrganizationsOrganizationMemberOrganizationIdMemberGetParams {
  /** An enumeration. */
  role: KeycloakRole;
  /** Organization Id */
  organizationId: string;
}

export interface DeleteOrganizationMemberV1OrganizationsOrganizationMemberOrganizationIdMemberDeleteParams {
  /** User Id */
  user_id: string;
  /** Organization Id */
  organizationId: string;
}

export interface GetUserOrganizationListV1OrganizationsUserIdOrganizationsGetParams {
  /** User Id */
  userId: string;
}

export interface GetOrganizationsForUsersV1OrganizationsOrganizationsByUsersGetParams {
  /** User Ids */
  user_ids: string;
}

export interface GetOrganizationsUsersByRoleV1OrganizationsOrganizationsUsersByRoleGetParams {
  /** Organization Ids */
  organization_ids: string;
  /** Role */
  role: string;
}

export interface GetOrganizationByIdV1OrganizationsOrganizationIdGetParams {
  /** Organization Id */
  organizationId: string;
}

export interface GetBillingOverviewV1StripeBillingOverviewGetParams {
  /** Organization Id */
  organization_id: string;
}

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  JsonApi = 'application/vnd.api+json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || 'http://0.0.0.0:8082',
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { 'Content-Type': type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Vestra Identity Center API
 * @version 1.0
 * @baseUrl http://0.0.0.0:8082
 *
 * Vestra Identity Center API 💅
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  healthcheck = {
    /**
     * No description
     *
     * @tags healthcheck
     * @name HealthcheckHealthcheckGet
     * @summary Healthcheck
     * @request GET:/healthcheck
     */
    healthcheckHealthcheckGet: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/healthcheck`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  v1 = {
    /**
     * No description
     *
     * @tags users
     * @name UpdateUserV1UsersPut
     * @summary Update User
     * @request PUT:/v1/users
     * @secure
     */
    updateUserV1UsersPut: (data: UpdateUserRequest, params: RequestParams = {}) =>
      this.request<UpdateUserResponse, HTTPValidationError>({
        path: `/v1/users`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags users
     * @name CreateUserV1UsersPost
     * @summary Create User
     * @request POST:/v1/users
     * @secure
     */
    createUserV1UsersPost: (data: CreateUserRequest, params: RequestParams = {}) =>
      this.request<CreateUserResponse, HTTPValidationError>({
        path: `/v1/users`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags users
     * @name GetUserOrganizationListV1UsersUserIdOrganizationsGet
     * @summary Get User Organization List
     * @request GET:/v1/users/{user_id}/organizations
     * @secure
     */
    getUserOrganizationListV1UsersUserIdOrganizationsGet: (
      { userId }: GetUserOrganizationListV1UsersUserIdOrganizationsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetUsersOrganizationListResponse, HTTPValidationError>({
        path: `/v1/users/${userId}/organizations`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags users
     * @name GetUsersByRoleV1UsersByRoleGet
     * @summary Get Users By Role
     * @request GET:/v1/users/by-role
     * @secure
     */
    getUsersByRoleV1UsersByRoleGet: (
      query: GetUsersByRoleV1UsersByRoleGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetUsersByRoleResponse, HTTPValidationError>({
        path: `/v1/users/by-role`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags users
     * @name GetUserDetailsByUserIdV1UsersDetailsUserIdGet
     * @summary Get User Details By User Id
     * @request GET:/v1/users/details/{user_id}
     * @secure
     */
    getUserDetailsByUserIdV1UsersDetailsUserIdGet: (
      { userId }: GetUserDetailsByUserIdV1UsersDetailsUserIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetUserDetailByUserIdResponse, HTTPValidationError>({
        path: `/v1/users/details/${userId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags users
     * @name UpdateUserProfileByComplianceAdminV1UsersUserIdProfilePut
     * @summary Update User Profile By Compliance Admin
     * @request PUT:/v1/users/{user_id}/profile
     * @secure
     */
    updateUserProfileByComplianceAdminV1UsersUserIdProfilePut: (
      { userId }: UpdateUserProfileByComplianceAdminV1UsersUserIdProfilePutParams,
      data: UpdateUserByComplianceAdminRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateUserByComplianceAdminResponse, HTTPValidationError>({
        path: `/v1/users/${userId}/profile`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags users
     * @name UpdateSignupReadinessV1UsersSignupReadinessPut
     * @summary Update Signup Readiness
     * @request PUT:/v1/users/signup-readiness
     * @secure
     */
    updateSignupReadinessV1UsersSignupReadinessPut: (
      data: UpdateSignupReadinessRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateSignupReadinessResponse, HTTPValidationError>({
        path: `/v1/users/signup-readiness`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags users
     * @name CreateMagicLinkV1UsersCreateMagicLinkPost
     * @summary Create Magic Link
     * @request POST:/v1/users/create-magic-link
     * @secure
     */
    createMagicLinkV1UsersCreateMagicLinkPost: (
      data: CreateMagicLinkRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateMagicLinkResponse, HTTPValidationError>({
        path: `/v1/users/create-magic-link`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags users
     * @name UpdateUserTotpStatusV1UsersUserIdOtpPost
     * @summary Update User Totp Status
     * @request POST:/v1/users/{user_id}/otp
     * @secure
     */
    updateUserTotpStatusV1UsersUserIdOtpPost: (
      { userId }: UpdateUserTotpStatusV1UsersUserIdOtpPostParams,
      data: UpdateUserTotpStatusPayload,
      params: RequestParams = {},
    ) =>
      this.request<UpdateUserTotpStatusResponse, HTTPValidationError>({
        path: `/v1/users/${userId}/otp`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags users
     * @name ResetUserTotpV1UsersUserIdReset2FaPost
     * @summary Reset User Totp
     * @request POST:/v1/users/{user_id}/reset-2fa
     * @secure
     */
    resetUserTotpV1UsersUserIdReset2FaPost: (
      { userId }: ResetUserTotpV1UsersUserIdReset2FaPostParams,
      params: RequestParams = {},
    ) =>
      this.request<ResetUserTotpResponse, HTTPValidationError>({
        path: `/v1/users/${userId}/reset-2fa`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags users
     * @name UpdateUserOrganizationRoleV1UsersUserOrganizationRolePut
     * @summary Update User Organization Role
     * @request PUT:/v1/users/user-organization-role
     * @secure
     */
    updateUserOrganizationRoleV1UsersUserOrganizationRolePut: (
      data: UpdateUserIssuerRoleRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateUserIssuerRoleResponse, HTTPValidationError>({
        path: `/v1/users/user-organization-role`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags users
     * @name UpdateUserComplianceRoleV1UsersUserRolePut
     * @summary Update User Compliance Role
     * @request PUT:/v1/users/user-role
     * @secure
     */
    updateUserComplianceRoleV1UsersUserRolePut: (
      data: UpdateUserComplianceRoleRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateUserComplianceRoleResponse, HTTPValidationError>({
        path: `/v1/users/user-role`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags users
     * @name DeleteUserComplianceRoleV1UsersUserRoleDelete
     * @summary Delete User Compliance Role
     * @request DELETE:/v1/users/user-role
     * @secure
     */
    deleteUserComplianceRoleV1UsersUserRoleDelete: (
      data: DeleteUserComplianceRoleRequest,
      params: RequestParams = {},
    ) =>
      this.request<DeleteUserComplianceRoleResponse, HTTPValidationError>({
        path: `/v1/users/user-role`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags organizations
     * @name CreateOrganizationV1OrganizationsPost
     * @summary Create Organization
     * @request POST:/v1/organizations
     * @secure
     */
    createOrganizationV1OrganizationsPost: (
      data: CreateOrganizationRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateOrganizationResponse, HTTPValidationError>({
        path: `/v1/organizations`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags organizations
     * @name DeleteOrganizationV1OrganizationsOrganizationOrganizationIdDelete
     * @summary Delete Organization
     * @request DELETE:/v1/organizations/organization/{organization_id}
     * @secure
     */
    deleteOrganizationV1OrganizationsOrganizationOrganizationIdDelete: (
      { organizationId }: DeleteOrganizationV1OrganizationsOrganizationOrganizationIdDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteOrganizationResponse, HTTPValidationError>({
        path: `/v1/organizations/organization/${organizationId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags organizations
     * @name AddOrganizationMemberV1OrganizationsOrganizationMemberOrganizationIdMemberUserIdRoleRolePut
     * @summary Add Organization Member
     * @request PUT:/v1/organizations/organization-member/{organization_id}/member/{user_id}/role/{role}/
     * @secure
     */
    addOrganizationMemberV1OrganizationsOrganizationMemberOrganizationIdMemberUserIdRoleRolePut: (
      {
        organizationId,
        userId,
        role,
      }: AddOrganizationMemberV1OrganizationsOrganizationMemberOrganizationIdMemberUserIdRoleRolePutParams,
      params: RequestParams = {},
    ) =>
      this.request<AddOrganizationMemberResponse, HTTPValidationError>({
        path: `/v1/organizations/organization-member/${organizationId}/member/${userId}/role/${role}/`,
        method: 'PUT',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags organizations
     * @name GetOrganizationMemberV1OrganizationsOrganizationMemberOrganizationIdMemberGet
     * @summary Get Organization Member
     * @request GET:/v1/organizations/organization-member/{organization_id}/member/
     * @secure
     */
    getOrganizationMemberV1OrganizationsOrganizationMemberOrganizationIdMemberGet: (
      {
        organizationId,
        ...query
      }: GetOrganizationMemberV1OrganizationsOrganizationMemberOrganizationIdMemberGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetOrganizationMemberResponse, HTTPValidationError>({
        path: `/v1/organizations/organization-member/${organizationId}/member/`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags organizations
     * @name DeleteOrganizationMemberV1OrganizationsOrganizationMemberOrganizationIdMemberDelete
     * @summary Delete Organization Member
     * @request DELETE:/v1/organizations/organization-member/{organization_id}/member/
     * @secure
     */
    deleteOrganizationMemberV1OrganizationsOrganizationMemberOrganizationIdMemberDelete: (
      {
        organizationId,
        ...query
      }: DeleteOrganizationMemberV1OrganizationsOrganizationMemberOrganizationIdMemberDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteOrganizationMemberResponse, HTTPValidationError>({
        path: `/v1/organizations/organization-member/${organizationId}/member/`,
        method: 'DELETE',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags organizations
     * @name GetUserOrganizationListV1OrganizationsUserIdOrganizationsGet
     * @summary Get User Organization List
     * @request GET:/v1/organizations/{user_id}/organizations
     * @secure
     */
    getUserOrganizationListV1OrganizationsUserIdOrganizationsGet: (
      { userId }: GetUserOrganizationListV1OrganizationsUserIdOrganizationsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetUsersOrganizationListResponse, HTTPValidationError>({
        path: `/v1/organizations/${userId}/organizations`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags organizations
     * @name GetOrganizationsForUsersV1OrganizationsOrganizationsByUsersGet
     * @summary Get Organizations For Users
     * @request GET:/v1/organizations/organizations-by-users
     * @secure
     */
    getOrganizationsForUsersV1OrganizationsOrganizationsByUsersGet: (
      query: GetOrganizationsForUsersV1OrganizationsOrganizationsByUsersGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetOrganizationsForUsersResponse, HTTPValidationError>({
        path: `/v1/organizations/organizations-by-users`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags organizations
     * @name GetOrganizationsUsersByRoleV1OrganizationsOrganizationsUsersByRoleGet
     * @summary Get Organizations Users By Role
     * @request GET:/v1/organizations/organizations-users-by-role
     * @secure
     */
    getOrganizationsUsersByRoleV1OrganizationsOrganizationsUsersByRoleGet: (
      query: GetOrganizationsUsersByRoleV1OrganizationsOrganizationsUsersByRoleGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetUsersByOrganizationRoleResponse, HTTPValidationError>({
        path: `/v1/organizations/organizations-users-by-role`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags organizations
     * @name AddOrganizationRoleV1OrganizationsAddOrganizationRolePut
     * @summary Add Organization Role
     * @request PUT:/v1/organizations/add-organization-role
     * @secure
     */
    addOrganizationRoleV1OrganizationsAddOrganizationRolePut: (
      data: AddOrganizationRoleRequest,
      params: RequestParams = {},
    ) =>
      this.request<AddOrganizationRoleResponse, HTTPValidationError>({
        path: `/v1/organizations/add-organization-role`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags organizations
     * @name DeleteOrganizationRoleV1OrganizationsOrganizationRoleDelete
     * @summary Delete Organization Role
     * @request DELETE:/v1/organizations/organization-role
     * @secure
     */
    deleteOrganizationRoleV1OrganizationsOrganizationRoleDelete: (
      data: DeleteOrganizationRoleRequest,
      params: RequestParams = {},
    ) =>
      this.request<DeleteOrganizationRoleResponse, HTTPValidationError>({
        path: `/v1/organizations/organization-role`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags organizations
     * @name UpdateOrganizationV1OrganizationsOrganizationPut
     * @summary Update Organization
     * @request PUT:/v1/organizations/organization
     * @secure
     */
    updateOrganizationV1OrganizationsOrganizationPut: (
      data: UpdateOrganizationRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateOrganizationResponse, HTTPValidationError>({
        path: `/v1/organizations/organization`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags organizations
     * @name GetOrganizationByIdV1OrganizationsOrganizationIdGet
     * @summary Get Organization By Id
     * @request GET:/v1/organizations/{organization_id}
     * @secure
     */
    getOrganizationByIdV1OrganizationsOrganizationIdGet: (
      { organizationId }: GetOrganizationByIdV1OrganizationsOrganizationIdGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetOrganizationByIdResponse, HTTPValidationError>({
        path: `/v1/organizations/${organizationId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags public
     * @name SignupV1PublicSignupPost
     * @summary Signup
     * @request POST:/v1/public/signup
     */
    signupV1PublicSignupPost: (data: SignupRequest, params: RequestParams = {}) =>
      this.request<SignupResponse, HTTPValidationError>({
        path: `/v1/public/signup`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags public
     * @name SsoCallbackV1PublicSignupSsoCallbackPost
     * @summary Sso Callback
     * @request POST:/v1/public/signup/sso-callback
     */
    ssoCallbackV1PublicSignupSsoCallbackPost: (
      data: SsoCallbackRequest,
      params: RequestParams = {},
    ) =>
      this.request<SsoCallbackResponse, HTTPValidationError>({
        path: `/v1/public/signup/sso-callback`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags public
     * @name SignupHandoffV1PublicSignupHandoffPost
     * @summary Signup Handoff
     * @request POST:/v1/public/signup/handoff
     */
    signupHandoffV1PublicSignupHandoffPost: (data: SignupHandoffBody, params: RequestParams = {}) =>
      this.request<SignupSessionResponse, HTTPValidationError>({
        path: `/v1/public/signup/handoff`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags public
     * @name RefreshSignupSessionV1PublicSignupRefreshSessionPost
     * @summary Refresh Signup Session
     * @request POST:/v1/public/signup/refresh-session
     */
    refreshSignupSessionV1PublicSignupRefreshSessionPost: (params: RequestParams = {}) =>
      this.request<SignupSessionResponse, any>({
        path: `/v1/public/signup/refresh-session`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags public
     * @name UpdateSignupSelectionV1PublicSignupSelectionPost
     * @summary Update Signup Selection
     * @request POST:/v1/public/signup/selection
     */
    updateSignupSelectionV1PublicSignupSelectionPost: (
      data: UpdateSignupSelectionBody,
      params: RequestParams = {},
    ) =>
      this.request<SignupSessionResponse, HTTPValidationError>({
        path: `/v1/public/signup/selection`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags public
     * @name SignupCompanyV1PublicSignupCompanyPost
     * @summary Signup Company
     * @request POST:/v1/public/signup/company
     */
    signupCompanyV1PublicSignupCompanyPost: (data: SignupCompanyBody, params: RequestParams = {}) =>
      this.request<SignupCompanyResponse, HTTPValidationError>({
        path: `/v1/public/signup/company`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags public
     * @name SignupSsoV1PublicSignupSsoPost
     * @summary Signup Sso
     * @request POST:/v1/public/signup/sso
     */
    signupSsoV1PublicSignupSsoPost: (data: SignupSsoBody, params: RequestParams = {}) =>
      this.request<SignupSsoResponse, HTTPValidationError>({
        path: `/v1/public/signup/sso`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags public
     * @name SsoLoginV1PublicSignupSsoLoginPost
     * @summary Sso Login
     * @request POST:/v1/public/signup/sso-login
     */
    ssoLoginV1PublicSignupSsoLoginPost: (params: RequestParams = {}) =>
      this.request<SsoLoginResponse, any>({
        path: `/v1/public/signup/sso-login`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags public
     * @name SignupOnboardingStatusV1PublicSignupOnboardingStatusGet
     * @summary Signup Onboarding Status
     * @request GET:/v1/public/signup/onboarding-status
     */
    signupOnboardingStatusV1PublicSignupOnboardingStatusGet: (params: RequestParams = {}) =>
      this.request<SignupOnboardingStatusResponse, any>({
        path: `/v1/public/signup/onboarding-status`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags public
     * @name SignupBillingPortalSessionV1PublicSignupBillingPortalSessionPost
     * @summary Signup Billing Portal Session
     * @request POST:/v1/public/signup/billing-portal-session
     */
    signupBillingPortalSessionV1PublicSignupBillingPortalSessionPost: (
      data: SignupBillingPortalSessionBody,
      params: RequestParams = {},
    ) =>
      this.request<SignupBillingPortalSessionResponse, any>({
        path: `/v1/public/signup/billing-portal-session`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags stripe
     * @name CreateCheckoutSessionV1StripeCheckoutSessionPost
     * @summary Create Checkout Session
     * @request POST:/v1/stripe/checkout-session
     */
    createCheckoutSessionV1StripeCheckoutSessionPost: (
      data: CreateCheckoutSessionBody,
      params: RequestParams = {},
    ) =>
      this.request<CreateCheckoutSessionResponse, HTTPValidationError>({
        path: `/v1/stripe/checkout-session`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags stripe
     * @name VerifyCheckoutSessionV1StripeVerifySessionPost
     * @summary Verify Checkout Session
     * @request POST:/v1/stripe/verify-session
     */
    verifyCheckoutSessionV1StripeVerifySessionPost: (
      data: VerifyCheckoutSessionBody,
      params: RequestParams = {},
    ) =>
      this.request<VerifyCheckoutSessionResponse, HTTPValidationError>({
        path: `/v1/stripe/verify-session`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags stripe
     * @name GetSubscriptionStatusV1StripeSubscriptionStatusGet
     * @summary Get Subscription Status
     * @request GET:/v1/stripe/subscription-status
     */
    getSubscriptionStatusV1StripeSubscriptionStatusGet: (params: RequestParams = {}) =>
      this.request<GetSubscriptionStatusResponse, any>({
        path: `/v1/stripe/subscription-status`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags stripe
     * @name CreateBillingPortalSessionV1StripeBillingPortalSessionPost
     * @summary Create Billing Portal Session
     * @request POST:/v1/stripe/billing-portal-session
     */
    createBillingPortalSessionV1StripeBillingPortalSessionPost: (
      data: CreateBillingPortalSessionBody,
      params: RequestParams = {},
    ) =>
      this.request<CreateBillingPortalSessionResponse, HTTPValidationError>({
        path: `/v1/stripe/billing-portal-session`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags stripe
     * @name GetBillingOverviewV1StripeBillingOverviewGet
     * @summary Get Billing Overview
     * @request GET:/v1/stripe/billing-overview
     */
    getBillingOverviewV1StripeBillingOverviewGet: (
      query: GetBillingOverviewV1StripeBillingOverviewGetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetBillingOverviewResponse, HTTPValidationError>({
        path: `/v1/stripe/billing-overview`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags webhooks
     * @name StripeWebhookV1WebhooksStripePost
     * @summary Stripe Webhook
     * @request POST:/v1/webhooks/stripe
     */
    stripeWebhookV1WebhooksStripePost: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/v1/webhooks/stripe`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags webhooks
     * @name KeycloakEventWebhookV1WebhooksKeycloakEventPost
     * @summary Keycloak Event Webhook
     * @request POST:/v1/webhooks/keycloak-event
     */
    keycloakEventWebhookV1WebhooksKeycloakEventPost: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/v1/webhooks/keycloak-event`,
        method: 'POST',
        format: 'json',
        ...params,
      }),
  };
}
